import WorkbenchActions from './actions'
import mutations from './mutations'
import { isEmpty } from 'lodash'
import { module as dateRange } from '@/appComponents/oldWorkbench/dateRange'
import WorkbenchWCanvasBaseStore from '@/views/workbenchCanvas/store/WorkbenchWCanvasBaseStore'
import RevisionHistoryStore from '@/appLogic/revisionHistory/store'
import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

class StoreAD extends WorkbenchWCanvasBaseStore {

  additionalState () {
    return {
      audienceSize: null,
      dayParts: [],
      historicalViewership: null,
      universe: null
    }
  }

  additionalGetters () {
    return {
      targetDefinition: (state, getters) => ({
        startDate: state.dateRange.startDate ? state.dateRange.startDate.from : '',
        endDate: state.dateRange.endDate ? state.dateRange.endDate.to : '',
        query: getters.serializedDefinition,
        networks: getters.selectedViewershipNetworks, // NETWORK
        viewSource: getters.streamingOption,
        promotedNetworks: getters.currentTarget && getters.currentTarget.promotedNetworks
      }),
      audienceSize: state => state.audienceSize,
      universe: state => state.universe,
      historicalViewership: state => state.historicalViewership,
      isTargetEmpty: (state, getters) => !!getters.targetDefinition && !!getters.targetDefinition.query && isEmpty(getters.targetDefinition.query),
      isTargetActivated: (state, getters) => {
        if (isEmpty(getters.currentTarget)) return false
        return getters.currentTarget.activated
      },
      isTargetArchived: (state, getters) => {
        if (isEmpty(getters.currentTarget)) return false
        return getters.currentTarget.archived
      },
      isTargetSubmitted: (state, getters) => {
        if (isEmpty(getters.currentTarget)) return false
        return getters.currentTarget.activation_status === ACTIVATION_STATUS.SUBMITTED
      }
    }
  }

  additionalMutations () {
    return {
      ...mutations
    }
  }

  createActions () {
    const WorkbenchActionsAD = new WorkbenchActions()
    WorkbenchActionsAD.setNamespace(this.namespace)
    return WorkbenchActionsAD.createActions()
  }

  additionalModules () {
    const modules = {
      dateRange,
      RevisionHistoryStore
    }
    return modules
  }

}

const module = function (namespace) {
  return new StoreAD(namespace).create()
}

export default module



// WEBPACK FOOTER //
// ./src/app/views/workbench/AD/store/index.js